import {Directive, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {isTenant, Tenant} from '../../website-configuration/tenant';

@Directive({
  selector: '[wvIsWarmeSteden]'
})
export class IsWarmeStedenDirective implements OnInit {

  private visible = false;

  constructor(private viewContainerRef: ViewContainerRef,
              private templateRef: TemplateRef<any>) {
  }

  ngOnInit() {
    if (isTenant(Tenant.WARME_STEDEN_EN_GEMEENTEN)) {
      this.visible = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.visible = false;
      this.viewContainerRef.clear();
    }
  }
}
